import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ReportsPage } from '../../components/reports/ReportsPage'

// Both filters live in the URL so a report scope is bookmarkable and
// shareable: `asset` is the building/site the outputs are generated for,
// `lens` the readiness prism (sale / bank / insurance).
const searchSchema = z.object({
  asset: z.string().optional(),
  lens: z.string().optional(),
})

export const Route = createFileRoute('/$org/reports')({
  validateSearch: searchSchema,
  component: ReportsPageRoute,
})

function ReportsPageRoute() {
  const { org } = Route.useParams()
  const search = Route.useSearch()
  return <ReportsPage org={org} assetUid={search.asset} lens={search.lens} />
}
